import React from 'react';

// Material UI
import FormControl from '@material-ui/core/FormControl/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// Components
import { FormikFieldLabel } from './formik-field-label.component';
import { FormikFieldCommonProps, useFormikField } from './use-formik-field';

interface IFormikCheckboxProps extends FormikFieldCommonProps {
  margin?: 'none' | 'dense' | 'normal';
  autoWidth?: boolean;
}

export const FormikCheckbox: React.FC<IFormikCheckboxProps> = ({ autoWidth, margin, field, form, fid, id, label, ...rest }) => {
  const { id: _id } = useFormikField({ field, form, fid, id });

  const checkbox = <Checkbox
    {...rest}
    id={_id}
    name={field.name}
    checked={Boolean(field.value)}
    onChange={field.onChange}
  />;

  const labelNode = <FormikFieldLabel label={label} htmlFor={_id} />;

  return (
    <FormControl margin={margin || 'normal'} fullWidth={!Boolean(autoWidth)} component="div" error={!!field.error}>
      {label ? <FormControlLabel control={checkbox} label={labelNode}/> : checkbox}
    </FormControl>
  );
};
